export default {
  months: [
    {
      value: 'selectMonth',
      index: 0
    },
    {
      value: 'jan',
      index: 1
    },
    {
      value: 'feb',
      index: 2
    },
    {
      value: 'mar',
      index: 3
    },
    {
      value: 'apr',
      index: 4
    },
    {
      value: 'may',
      index: 5
    },
    {
      value: 'jun',
      index: 6
    },
    {
      value: 'jul',
      index: 7
    },
    {
      value: 'aug',
      index: 8
    },
    {
      value: 'sep',
      index: 9
    },
    {
      value: 'oct',
      index: 10
    },
    {
      value: 'nov',
      index: 11
    },
    {
      value: 'dec',
      index: 12
    },
  ]
};



// WEBPACK FOOTER //
// ./src/constants/months.js